import i from "react";
import { Card as e } from "../../../../../../../Card/Card.js";
import "../../../../../../../Accordion/Accordion.js";
import "../../../../../../../AdCard/AdCard.js";
import "../../../../../../../AdCardImageCarousel/AdCardImageCarousel.js";
import "../../../../../../../AdMediaCounter/AdMediaCounter.js";
import "../../../../../../../Alertbox/Alertbox.js";
import "../../../../../../../Alertbox/Links.js";
import "../../../../../../../ArrowButton/ArrowButton.js";
import "../../../../../../../Autocomplete/Autocomplete.js";
import "../../../../../../../Autocomplete/AutocompleteListItem.js";
import "../../../../../../../Avatar/Avatar.js";
import "../../../../../../../Badge/Badge.js";
import "../../../../../../../Breadcrumb/Breadcrumb.js";
import "../../../../../../../Button/Button.js";
import "../../../../../../../ButtonSocial/ButtonSocial.js";
import "../../../../../../../CardCoverImage/CardCoverImage.js";
import "../../../../../../../CardSuggestion/CardSuggestion.js";
import "../../../../../../../CardTopImage/CardTopImage.js";
import "../../../../../../../Carousel/Carousel.js";
import "../../../../../../../Carousel/components/CarouselNext.js";
import "../../../../../../../Carousel/components/CarouselPrevious.js";
import "../../../../../../../Carousel/components/CarouselContent.js";
import "../../../../../../../Carousel/components/CarouselItem.js";
import "embla-carousel-autoplay";
import "embla-carousel-react";
import "../../../../../../../Checkbox/Checkbox.js";
import "../../../../../../../Chip/Chip.js";
import "../../../../../../../Chips/Chips.js";
import "../../../../../../../Container/Container.js";
import "../../../../../../../Divider/Divider.js";
import "../../../../../../../Dropdown/Dropdown.js";
import { Flex as a } from "../../../../../../../Flex/Flex.js";
import "../../../../../../../FocusHeader/FocusHeader.js";
import "../../../../../../../Footer/Footer.js";
import "../../../../../../../FormControl/FormControl.js";
import "../../../../../../Header.js";
import "../../../../../../../HelpText/HelpText.js";
import "../../../../../../../IconAction/IconAction.js";
import "../../../../../../../ImageCarousel/ImageCarousel.js";
import "../../../../../../../InputChips/InputChips.js";
import "../../../../../../../LayoutContainer/LayoutContainer.js";
import "../../../../../../../Link/Link.js";
import "../../../../../../../LogoCompraSegura/LogoCompraSegura.js";
import "../../../../../../../LogoOLX/LogoOLX.js";
import "../../../../../../../LogoOLXPay/LogoOLXPay.js";
import "../../../../../../../LogoOLXPayPlusDelivery/LogoOLXPayPlusDelivery.js";
import "../../../../../../../Lurker/Lurker.js";
import "../../../../../../../MediaCounter/MediaCounter.js";
import "../../../../../../../Modal/Modal.js";
import "../../../../../../../Multiselect/Multiselect.js";
import "../../../../../../../Navbar/Navbar.js";
import "../../../../../../../Overflow/Overflow.js";
import "../../../../../../../PriceReferenceRuler/PriceReferenceRuler.js";
import "../../../../../../../ProgressBar/ProgressBar.js";
import "../../../../../../../ProgressCircle/ProgressCircle.js";
import "../../../../../../../ProgressStepped/ProgressStepped.js";
import "../../../../../../../Radio/Radio.js";
import "../../../../../../../Skeleton/Skeleton.js";
import "../../../../../../../Slider/Slider.js";
import "../../../../../../../Slider/RangeSlider.js";
import "../../../../../../../Spinner/Spinner.js";
import "../../../../../../../Tabs/Tabs.js";
import "../../../../../../../Tabs/components/Tab/Tab.js";
import { Text as l } from "../../../../../../../Text/Text.js";
import "../../../../../../../TextArea/TextArea.js";
import "../../../../../../../TextInput/TextInput.js";
import "../../../../../../../Toast/Toast.js";
import "../../../../../../../ToggleSwitch/ToggleSwitch.js";
import "../../../../../../../Tooltip/Tooltip.js";
import "clsx";
var n = Object.defineProperty,
  m = Object.getOwnPropertySymbols,
  c = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  p = (r, t, o) => t in r ? n(r, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : r[t] = o,
  f = (r, t) => {
    for (var o in t || (t = {})) c.call(t, o) && p(r, o, t[o]);
    if (m) for (var o of m(t)) b.call(t, o) && p(r, o, t[o]);
    return r;
  };
const u = r => i.createElement(e, f({
  className: "olx-header__tile-button",
  "data-ds-component": "DS-Tile",
  tag: "button",
  variant: "outlined"
}, r), i.createElement(a, {
  className: "olx-header__tile-button__upper-flex"
}, r.image, r.badge), i.createElement(l.Caption, null, r.title));
export { u as Tile };